// extracted by mini-css-extract-plugin
export default {"pageContentWrapper":"pageContentWrapper_pageContentWrapper__Qre-z","pageContent":"pageContentWrapper_pageContent__Jhq7H"};